import React from 'react'
import { Outlet } from 'react-router-dom'
import { isCustomerSite } from '../utils/getsubDomain'
import PageNotFound from './PageNotFound'
import { customerUnauthorizedPage } from '../utils/auth/customerAuth'

export default function RootWrapper() {
    if(isCustomerSite()) {
        if(customerUnauthorizedPage())
            return <div className='min-h-screen flex flex-col items-center justify-center'><PageNotFound /></div>
    }
    
  return <Outlet />
}
